import { WellTypeList } from './enums';

export const LABELS: { [key: string]: string } = {
  [WellTypeList.plugAbandonment]: 'Plug & Abandonment',
};
